angular.module('olivioConfiguratorApp')
  .controller('PowerCtrl', function ($scope, Model, Data, StepService) {
    //console.log('init PowerCtrl');

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;


    $scope.selectPower = function ($id) {
      var power = Data.getPowerOption($id);
      if (power) {
        if (power !== $scope.model.power.id) {
          $scope.model.power.id = $id;
          $scope.model.power.individual = new Array($scope.model.design.lumcount);
          for (var i = 0; i < $scope.model.design.lumcount; i++) {
            $scope.model.power.individual[i] = $id;
          }
        }
        $scope.model.power.done = true;
        StepService.updateEnabled();
        StepService.nextStep();
      }
    };

    (function () {  // init
      // check conditions
      Data.applyPowerConstraints($scope.model);
      $scope.powerOptions = [];
      for(var i=0;i<Data.powerOptions.length;i++) {
        if(!Data.powerOptions[i].disabled) {
          $scope.powerOptions.push(Data.powerOptions[i]);
        }
      }
      console.log('power init', {powerOptions: $scope.powerOptions});
      if($scope.powerOptions.length === 1) {
        $scope.selectPower($scope.powerOptions[0].id);
        StepService.configurationSteps.filter(s => s.view === 'power')[0].skipped = true;
      }

    })();

  });
